import { createSelector } from 'reselect';
import { ModalType } from 'enums';
import appSelector from './appSelector';


export const activationSelector = createSelector(
    ({ activation = {} }) => activation,
    (activation) => activation
);

export const configSelector = createSelector(
    activationSelector,
    ({ config = {} } = {}) => config
);

export const regCodeSelector = createSelector(
    activationSelector,
    ({ regCode = {} } = {}) => regCode
);

export const authenticateSelector = createSelector(
    activationSelector,
    ({ authenticate = {} } = {}) => authenticate
);

export const isIframeClosedSelector = createSelector(
    appSelector,
    ({ showModalMessage = false, lastMessageType = '' } = {}) => (
        !showModalMessage && lastMessageType === ModalType.IFRAME_AUTH
    )
);



// WEBPACK FOOTER //
// ./app/selectors/activationSelectors.js